export const positiveFloatRegex = /^(?!0\d)\d*(\.\d+)?$/

export const numbersAndDecimalRegex = /[0-9.]/g
export const notNumbersAndDecimalRegex = /[^0-9.]/g

export const isPositiveFloat = (value: any) => {
  return positiveFloatRegex.test(value)
}

export const normalizePositiveFloat = (value: string) => {
  const val = value.replace(notNumbersAndDecimalRegex, '')
  if (val) {
    if (val && positiveFloatRegex.test(val)) {
      console.log('TRUE', value)
      return +value
    } else {
      console.log('FALSE')
      return val
    }
  } else {
    return null
  }
}
